import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';

import '@webs/components-library/button';
import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles
} from '@webs/components-library/theming';
import { ifDefined } from 'lit/directives/if-defined.js';

@customElement('webs-cta-newsletter')
export class CtaNewsletter extends LitElement {

  static styles = [
    moduleSpacingStyles,
    normalizeStyles,
    containerStyles,
    typographyStyles,
    css`
    :host{
      --intro-font-size: 1.2rem;
      --intro-line-height: 1.3;
      --button-background-color: var(--color-base);
      --button-border-radius: 2.1rem;
      --button-color: var(--color-white);
      --button-font-family: var(--font-family-alternative);
      --button-font-weight: var(--font-weight-strong);
      --button-padding: .65rem 1.5rem;
    }

    ::slotted([slot="title"]),
    .cta-newsletter__description ::slotted(*) {
      text-align: center;
    }

    ::slotted([slot="title"]),
    .cta-newsletter__description {
      margin: 0 auto 1.4rem !important;
      max-width: 624px !important;
    }

    .cta-newsletter__description p,
    .cta-newsletter__description li,
    .cta-newsletter__description a:not(.button),
    .cta-newsletter__description a:not(.cta_button) {
      font-family: var(--font-family-base);
      font-size: var(--intro-font-size);
      line-height: var(--intro-line-height);
    }

    .cta-newsletter__form-wrapper {
      margin-top: 1.6rem;
      text-align: center;
    }

    .cta-newsletter__form-wrapper .title {
      align-items: center;
      background: var(--button-background-color);
      border-radius: var(--button-border-radius);
      color: var(--button-color);
      display: inline-flex;
      font: var(--button-font-weight) 0.8rem/1.3 var(--button-font-family);
      justify-content: center;
      margin: 0;
      outline: none;
      overflow: hidden;
      padding: var(--button-padding);
      z-index: 1;
    }

    .cta-newsletter__form-wrapper .title,
    .cta-newsletter__form-wrapper webs-button {
      display: block;
      margin-bottom: .8rem;
    }

    .cta-newsletter__form-wrapper webs-button::part(button) {
      width: 100%;
    }

    .cta-newsletter__form {
      background: rgba(24, 26, 35, 0.06);
      border-radius: 4.5rem;
      padding: .65rem 1rem .65rem .6rem;
    }

    @media only screen and (min-width: 576px){
      .cta-newsletter__form-wrapper {
        display: flex;
        justify-content: center;
        flex: 1;
        margin: 0 auto;
        max-width: 460px;
      }

      .cta-newsletter__form-wrapper .title,
      .cta-newsletter__form-wrapper webs-button {
        margin-bottom: 0;
      }

      .cta-newsletter__form-wrapper webs-button::part(button) {
        width: auto;
      }

      .cta-newsletter__form {
        margin-left: -2rem;
        flex: 1;
      }

      .cta-newsletter__form ::slotted(.newsletter-form) {
        margin-left: 2rem;
      }
    }
  `
  ];

  @property()
  id: string;
  @property({attribute: 'space-top'})
  spaceTop = 'm';
  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  @property({attribute: 'cta-text'})
  ctaText = 'Subscribe';

  @property({attribute: 'cta-form-ids', type: Array})
  ctaFormIds: string[];

  protected render(): unknown {
    return html`
      <section id="${ifDefined(this.id)}"
               class="cta-newsletter ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
        <div part="container" class="container">
          <slot name="title"></slot>

          <div part="intro" class="cta-newsletter__description">
            <slot name="description"></slot>
          </div>

          <div class="cta-newsletter__form-wrapper">
            ${this.ctaFormIds.length > 1 ? html`
              <webs-button text="${this.ctaText}" type="selector" .selectOptions="${this.ctaFormIds}"></webs-button>
            `: html`
              <p class="title">${this.ctaText}</p>
            `}

            <div class="cta-newsletter__form">
              <slot></slot>
            </div>
          </div>
        </div>
      </section>
    `
  }
}
